import { Button, Slider, Switch } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CommonUrl, NONCE, processMsg, TIME_STAMP } from '../../../common-url/CommonUrl';

export default function SettingForm(selectedRowData) {
    const desc = selectedRowData.data.vDesc;
    const sw = selectedRowData.data.vValue;
    const history = useHistory();
    const [name, setName] = useState()
    const [fourSwitch, setFourSwitch] = useState({});
    const [eightSwitch, setEightSwitch] = useState({});
    const [settingValue, setSettingValue] = useState({})
    const [description, setDescription] = useState({});
    const [loading, setLoading] = useState(false);
    const [icons, setIcons] = useState([])
    const marks = [
        { value: 0, label: '0' }, { value: 1, label: '1', },
        { value: 2, label: '2', }, { value: 3, label: '3', },
        { value: 4, label: '4', }, { value: 5, label: '5', },
    ]
    const marksBrightness = [
        { value: 0, label: '0', }, { value: 25, label: '25', },
        { value: 50, label: '50', }, { value: 75, label: '75', },
        { value: 100, label: '100', },
    ];

    const labelStyle = {
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        alignSelf: "stretch"
    }

    useEffect(() => {
        if (sw.S8 >= 0) {
            setEightSwitch(sw)
            setDescription(desc)
            setName(selectedRowData.data.vName)
        } else {
            setFourSwitch(sw)
            setSettingValue(sw)
            setDescription(desc)
            setName(selectedRowData.data.vName)
        }
    }, [desc, selectedRowData.data.vName, sw]);

    useEffect(() => {
        fetchIcons()
    }, [])

    const encToken = useSelector(({ auth }) => auth.authToken, shallowEqual);

    const handleCloseSuccess = () => {
        history.push("/default-settings")
    }

    const fetchIcons = async () => {
        await fetch(CommonUrl.iconBaseUrl + "/get-all-icons", {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                token: encToken,
                nonce: NONCE,
                timestamp: TIME_STAMP
            }
        })
            .then(response => response.json())
            .then(response => {
                if (response.code == 401) {
                    history.push("/logout");
                } else {
                    setIcons(response.data);
                }
            });
    };
    // console.log(icons, "icons.......")
    // ------------------------------------------------------------
    //                submit data of 4 switches
    // ------------------------------------------------------------
    const handleSubmitFour = (e) => {
        e.preventDefault();
        setLoading(true);
        const id = toast.loading(processMsg);
        fetch(CommonUrl.defaultSettingsBaseUrl + "/update", {
            method: "put",
            headers: {
                'Content-Type': 'application/json',
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP
            },
            body: JSON.stringify({
                _id: selectedRowData.data._id,
                vName: name,
                vValue: fourSwitch
            })
        }).then(response => response.json()).then(response => {
            if (response.code === 200) {
                toast.update(id, { render: response.message, type: "success", isLoading: false, autoClose: 3000 });
                handleCloseSuccess();
                setLoading(false);
            } else {
                toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000 });
            }
        })
    }
    // ------------------------------------------------------------
    //                submit data of 8 switches
    // ------------------------------------------------------------
    const handleSubmitEight = (e) => {
        e.preventDefault();
        setLoading(true);
        const id = toast.loading(processMsg);
        fetch(CommonUrl.defaultSettingsBaseUrl + "/update", {
            method: "put",
            headers: {
                'Content-Type': 'application/json',
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP
            },
            body: JSON.stringify({
                _id: selectedRowData.data._id,
                vName: name,
                vValue: eightSwitch
            })
        }).then(response => response.json()).then(response => {
            if (response.code === 200) {
                toast.update(id, { render: response.message, type: "success", isLoading: false, autoClose: 3000 });
                handleCloseSuccess();
                setLoading(false);
            } else {
                toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000 });
            }
        })
    }

    const handleSubmitSetting = (e) => {
        e.preventDefault();
        setLoading(true);
        const id = toast.loading(processMsg);
        // console.log(name, ".....name.....", settingValue, "settingValue,,,,,,,,,,")
        fetch(CommonUrl.defaultSettingsBaseUrl + "/update", {
            method: "put",
            headers: {
                'Content-Type': 'application/json',
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP
            },
            body: JSON.stringify({
                _id: selectedRowData.data._id,
                vName: name,
                vValue: settingValue
            })
        }).then(response => response.json()).then(response => {
            if (response.code === 200) {
                toast.update(id, { render: response.message, type: "success", isLoading: false, autoClose: 3000 });
                handleCloseSuccess();
                setLoading(false);
            } else {
                toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000 });
            }
        })
    }
    // ------------------------------------------------------------
    //                        form of 4 sw
    // ------------------------------------------------------------
    if (selectedRowData.data.vSettingKey == "4_MODULE_DEFULT_SETTING") {
        return (
            <>
                <hr className="solid m-4"></hr>
                <div className="container  ">
                    <div className="ml-5">
                        <form onSubmit={handleSubmitFour}>

                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="form-group ">
                                        <label className="  col-form-label font-weight-bold">Name</label>
                                        <input type="text"
                                            className="form-control  "
                                            onInvalid={(e) => e.target.setCustomValidity('Enter Name')}
                                            onInput={(e) => e.target.setCustomValidity('')}
                                            defaultValue={selectedRowData.data.vName}
                                            onChange={(e) => { setName(e.target.value) }}
                                            required />
                                    </div>
                                </div>
                                <div className="col-sm-3 mt-4 form-group text-center">
                                    <label className="col-sm-12 font-weight-bold">{description.S1 == null ? ("S1") : ("S1" + ": " + description.S1)}</label>
                                    <Switch
                                        className="form-control col-sm-12"
                                        defaultChecked={Boolean(sw.S1)}
                                        onChange={(e, value) => setFourSwitch({ ...fourSwitch, S1: Number(value) })}
                                        name="S1"
                                        color="primary" />
                                </div>
                                <div className="col-sm-3 mt-4 form-group text-center">
                                    <label className="col-sm-12 font-weight-bold">{description.S2 == null ? ("S2") : ("S2" + ": " + description.S2)}</label>
                                    <Switch
                                        className="form-control col-sm-12"
                                        defaultChecked={Boolean(sw.S2)}
                                        onChange={(e, value) => setFourSwitch({ ...fourSwitch, S2: Number(value) })}
                                        name="S2"
                                        color="primary" />
                                </div>
                            </div>

                            <div className="row text-center">
                                <div className="col-sm-3">
                                    <label className="font-weight-bold col-form-label">
                                        {description.DMR == null ? ("DMR") : ("DMR" + ": " + description.DMR)}
                                    </label>
                                    <Slider
                                        defaultValue={sw.DMR}
                                        value={marks.value}
                                        aria-labelledby="discrete-slider"
                                        valueLabelDisplay="auto"
                                        step={1}
                                        min={0}
                                        max={5}
                                        marks={marks}
                                        onChangeCommitted={(e, value) => setFourSwitch({ ...fourSwitch, DMR: value })}
                                    />
                                </div>
                                <div className="col-sm-3">
                                    <label className="col-sm-12 font-weight-bold">{description.S3 == null ? ("S3") : ("S3" + ": " + description.S3)}</label>
                                    <Switch
                                        className="form-control col-sm-12"
                                        defaultChecked={Boolean(sw.S3)}
                                        onChange={(e, value) => setFourSwitch({ ...fourSwitch, S3: Number(value) })}
                                        name="S3"
                                        color="primary" />
                                </div>
                                <div className="col-sm-3">
                                    <label className="col-sm-12 font-weight-bold"> {description.S4 == null ? ("S4") : ("S4" + ": " + description.S4)}</label>
                                    <Switch
                                        className="form-control col-sm-12"
                                        defaultChecked={Boolean(sw.S4)}
                                        onChange={(e, value) => setFourSwitch({ ...fourSwitch, S4: Number(value) })}
                                        name="S4"
                                        color="primary" />
                                </div>
                                <div className="col-sm-3">
                                    <label className="font-weight-bold col-sm-12 "> {description.USB_C == null ? ("USB_C") : ("USB_C" + ": " + description.USB_C)}</label>
                                    <Switch
                                        className=" form-control col-sm-12"
                                        defaultChecked={Boolean(sw.USB_C)}
                                        onChange={(e, value) => setFourSwitch({ ...fourSwitch, USB_C: Number(value) })}
                                        name="USB_C"
                                        color="primary" />
                                </div>
                            </div>
                            <div className="row form-group mt-3 justify-content-sm-center ">
                                <Button type="submit" disabled={loading} className="col-sm-4 btn btn-light-primary px-9 py-3 my-3">
                                    <span>Submit</span>
                                    {loading && <span className="ml-3 spinner spinner-dark"></span>}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div >
            </>
        )
    }
    // ------------------------------------------------------------
    //                        form of 8 sw
    // ------------------------------------------------------------
    else if (selectedRowData.data.vSettingKey == "8_MODULE_DEFULT_SETTING") {
        return (
            <>
                <hr className="solid m-4"></hr>
                <div className=" container">
                    <form onSubmit={handleSubmitEight}>
                        <div className="row mt-5">
                            <div className="col-sm-11 ml-8 form-group">
                                <label className="font-weight-bold col-sm-12">Name :</label>
                                <input type="text" className="form-control "
                                    defaultValue={selectedRowData.data.vName}
                                    onChange={(e) => { setName(e.target.value) }}
                                    required />
                            </div>
                        </div>
                        <div className="row text-center form-group">
                            <div className="col-sm-3 text-center">
                                <label className="font-weight-bold col-sm-12">{description.S1 == null ? ("S1") : ("S1" + ": " + description.S1)}</label>
                                <Switch
                                    className="form-control col-sm-12"
                                    defaultChecked={Boolean(sw.S1)}
                                    onChange={(e, value) => setEightSwitch({ ...eightSwitch, S1: Number(value) })}
                                    name="S1"
                                    color="primary" />
                            </div>
                            <div className="col-sm-3 text-center">
                                <label className="font-weight-bold col-sm-12">{description.S2 == null ? ("S2") : ("S2" + ": " + description.S2)}</label>
                                <Switch
                                    className="form-control col-sm-12"
                                    defaultChecked={Boolean(sw.S2)}
                                    onChange={(e, value) => setEightSwitch({ ...eightSwitch, S2: Number(value) })}
                                    name="S2"
                                    color="primary" />
                            </div>
                            <div className="col-sm-3">
                                <label className="font-weight-bold col-sm-12">{description.S3 == null ? ("S3") : ("S3" + ": " + description.S3)}</label>
                                <Switch
                                    className="form-control col-sm-12"
                                    defaultChecked={Boolean(sw.S3)}
                                    onChange={(e, value) => setEightSwitch({ ...eightSwitch, S3: Number(value) })}
                                    name="S3"
                                    color="primary" />
                            </div>
                            <div className="col-sm-3">
                                <label className="font-weight-bold col-sm-12">{description.S4 == null ? ("S4") : ("S4" + ": " + description.S4)}</label>
                                <Switch
                                    className="form-control col-sm-12"
                                    defaultChecked={Boolean(sw.S4)}
                                    onChange={(e, value) => setEightSwitch({ ...eightSwitch, S4: Number(value) })}
                                    name="S4"
                                    color="primary" />
                            </div>
                        </div>

                        <div className="row form-group text-center mt-5">
                            <div className="col-sm-3">
                                <label className="font-weight-bold col-sm-12">  {description.S5 == null ? ("S5") : ("S5" + ": " + description.S5)}</label>
                                <Switch
                                    className="form-control col-sm-12"
                                    defaultChecked={Boolean(sw.S5)}
                                    onChange={(e, value) => setEightSwitch({ ...eightSwitch, S5: Number(value) })}
                                    name="S5"
                                    color="primary" />
                            </div>
                            <div className="col-sm-3">
                                <label className="font-weight-bold col-sm-12">  {description.S6 == null ? ("S6") : ("S6" + ": " + description.S6)}</label>
                                <Switch
                                    className="form-control col-sm-12"
                                    defaultChecked={Boolean(sw.S6)}
                                    onChange={(e, value) => setEightSwitch({ ...eightSwitch, S6: Number(value) })}
                                    name="S6"
                                    color="primary" />
                            </div>
                            <div className="col-sm-3">
                                <label className="font-weight-bold col-sm-12">  {description.S7 == null ? ("S7") : ("S7" + ": " + description.S7)}</label>
                                <Switch
                                    className="form-control col-sm-12"
                                    defaultChecked={Boolean(sw.S7)}
                                    onChange={(e, value) => setEightSwitch({ ...eightSwitch, S7: Number(value) })}
                                    name="S7"
                                    color="primary" />
                            </div>
                            <div className="col-sm-3">
                                <label className="font-weight-bold col-sm-12"> {description.S8 == null ? ("S8") : ("S8" + ": " + description.S8)}</label>
                                <Switch
                                    className="form-control col-sm-12"
                                    defaultChecked={Boolean(sw.S8)}
                                    onChange={(e, value) => setEightSwitch({ ...eightSwitch, S8: Number(value) })}
                                    name="S8"
                                    color="primary" />
                            </div>
                        </div>

                        <div className="form-group row text-center mt-5">
                            <div className="col-md-6">
                                <div className=" text-center">
                                    <label className="font-weight-bold col-sm-12"> {description.DMR == null ? ("DMR") : ("DMR" + ": " + description.DMR)}</label>
                                    <div className="col-sm-12 mx-6">
                                        <Slider
                                            defaultValue={sw.DMR}
                                            value={marks.value}
                                            aria-labelledby="discrete-slider"
                                            valueLabelDisplay="auto"
                                            step={1}
                                            min={0}
                                            max={5}
                                            marks={marks}
                                            onChangeCommitted={(e, value) => setEightSwitch({ ...eightSwitch, DMR: value })}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <label className="font-weight-bold col-sm-12"> {description.USB_A == null ? ("USB_A") : ("USB_A" + ": " + description.USB_A)}</label>
                                <Switch
                                    className="form-control col-sm-12"
                                    defaultChecked={Boolean(sw.USB_A)}
                                    onChange={(e, value) => setEightSwitch({ ...eightSwitch, USB_A: Number(value) })}
                                    name="USB_A"
                                    color="primary" />
                            </div>
                            <div className="col-md-3">
                                <label className="font-weight-bold col-sm-12"> {description.USB_C == null ? ("USB_C") : ("USB_C" + ": " + description.USB_C)}</label>
                                <Switch
                                    className="form-control col-sm-12"
                                    defaultChecked={Boolean(sw.USB_C)}
                                    onChange={(e, value) => setEightSwitch({ ...eightSwitch, USB_C: Number(value) })}
                                    name="USB_C"
                                    color="primary" />
                            </div>
                        </div>
                        <div className="row form-group mt-3 justify-content-sm-center ">
                            <Button type="submit" disabled={loading} className="col-sm-4 btn btn-light-primary px-9 py-3 my-3">
                                <span>Submit</span>
                                {loading && <span className="ml-3 spinner spinner-dark"></span>}
                            </Button>
                        </div>
                    </form>
                </div >
            </>
        )
    }
    // ------------------------------------------------------------
    //                form of customizational setting
    // ------------------------------------------------------------
    else if (selectedRowData.data.vSettingKey == "CUSTOMIZATION_SETTING") {
        return (
            <>
                <hr className="solid m-7"></hr>
                <div className="px-5" >
                    <form onSubmit={handleSubmitSetting}>
                        <div className="row mx-auto">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label className="col-sm-12 col-form-label font-weight-bold">Name</label>
                                    <div className="">
                                        <input type="text" className="form-control"
                                            defaultValue={selectedRowData.data.vName}
                                            onInvalid={(e) => e.target.setCustomValidity('Enter the Name')}
                                            onInput={(e) => e.target.setCustomValidity('')}
                                            onChange={(e) => { setName(e.target.value) }}
                                            required />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-sm-12 col-form-label font-weight-bold">Screen Layout Type</label>
                                    <select
                                        className="form-control form-select"
                                        defaultValue={sw.ScreenLayoutType}
                                        onInvalid={(e) => e.target.setCustomValidity('Select Layout Type')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        onChange={(e) => setSettingValue({ ...settingValue, ScreenLayoutType: e.target.value })}
                                        required
                                    >
                                        <option value="" disabled>Select</option>
                                        <option value="8">8-Icons</option>
                                        <option value="6">6-Icons</option>
                                        <option value="4">4-Icons</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-12 col-form-label font-weight-bold ">Switch Icon Size
                                        <span className="ml-3" style={{ "font-size": "0.5rem" }}>
                                            {settingValue.SwitchIconSize == "Small" ? (<i className="fas fa-camera fa-lg"></i>) :
                                                settingValue.SwitchIconSize == "Medium" ? (<i className="fas fa-camera fa-2x"></i>) : (<i className="fas fa-camera fa-3x"></i>)}
                                        </span></label>
                                    <select
                                        className="form-control form-select"
                                        defaultValue={sw.SwitchIconSize}
                                        onInvalid={(e) => e.target.setCustomValidity('Select Icon Size')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        onChange={(e) => setSettingValue({ ...settingValue, SwitchIconSize: e.target.value })}
                                        required>
                                        <option value="" disabled>Select</option>
                                        <option value="Small">Small</option>
                                        <option value="Medium">Medium</option>
                                        <option value="Large">Large</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label className="col-sm-12 col-form-label font-weight-bold">Text Colour : <span>{settingValue.TextColor}</span> </label>
                                    <input className="form-control"
                                        type="color"
                                        name="TextColor"
                                        defaultValue={sw.TextColor}
                                        onChange={(e) => setSettingValue({ ...settingValue, TextColor: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label className="col-sm-12 col-form-label font-weight-bold" >Text Style</label>
                                    <select
                                        className="form-control form-select"
                                        defaultValue={sw.TextStyle}
                                        onInvalid={(e) => e.target.setCustomValidity('Select Text Style')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        onChange={(e) => setSettingValue({ ...settingValue, TextStyle: e.target.value })}
                                        required
                                    >
                                        <option value="Times New Roman">Times New Roman</option>
                                        <option value="Roman">Roman</option>
                                        <option value="Arial">Arial</option>
                                        <option value="Verdana">Verdana</option>
                                        <option value="Roboto">Roboto</option>
                                    </select>
                                </div>


                                <div className="form-group">
                                    <label className="col-sm-12 col-form-label font-weight-bold" >Screen Layout</label>
                                    <select
                                        className="form-control form-select"
                                        onInvalid={(e) => e.target.setCustomValidity('Select Screen Layout')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        defaultValue={sw.ScreenLayout}
                                        onChange={(e) => setSettingValue({ ...settingValue, ScreenLayout: e.target.value })}
                                        required
                                    >
                                        <option value="" disabled>Select</option>
                                        <option value="left_most"> Left Most </option>
                                        <option value="right_most">Right Most</option>
                                        <option value="left_right">Left and Right</option>
                                        <option value="middle_center">Middle Center</option>
                                        <option value="top_center">Top Center</option>
                                        <option value="bottom_center">Bottom Center</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-12 col-form-label font-weight-bold">Icon :</label>
                                    <select
                                        className="form-control form-select"
                                        value={settingValue?.vIconFile}
                                        onInvalid={(e) => e.target.setCustomValidity('Select Icon')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        onChange={(e) => setSettingValue({ ...settingValue, vIconFile: e.target.value })}
                                        required
                                    >
                                        {/* <option value="" disabled selected={!sw.IconName}>Select Icon</option> */}
                                        {icons && icons.map((icon) => {
                                            return (<option value={icon.vIconFile}>{icon.vIconName}</option>)
                                        })

                                        }
                                        {/* <option value="" disabled>Select</option>
                                        <option value="Small">Small</option>
                                        <option value="Medium">Medium</option>
                                        <option value="Large">Large</option> */}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-12 col-form-label font-weight-bold">Display Switch Name :
                                        <span className={settingValue.DisplaySwitchName ? ("text-success") : ("text-danger")}>
                                            {settingValue.DisplaySwitchName ? (" Yes") : (" No")}</span></label>
                                    <div className="mx-auto">
                                        <Switch
                                            className="form-control"
                                            defaultChecked={Boolean(sw.DisplaySwitchName)}
                                            onChange={(e, value) => setSettingValue({ ...settingValue, DisplaySwitchName: Number(value) })}
                                            name="DisplaySwitchName"
                                            color="primary" />

                                    </div>
                                </div>
                            </div>
                            <div className="row form-group mt-3 justify-content-sm-center ml-1">
                                <Button type="submit" disabled={loading} className="col-sm-4 btn btn-light-primary px-9 py-3 my-3">
                                    <span>Submit</span>
                                    {loading && <span className="ml-3 spinner spinner-dark"></span>}
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>

            </>
        )
    }
    // ------------------------------------------------------------
    //                form of feature setting
    // ------------------------------------------------------------
    else if (selectedRowData.data.vSettingKey == "FEATURE_SETTING") {
        return (
            <>
                <hr className="solid m-7"></hr>
                <div className="container px-10" >
                    <form onSubmit={handleSubmitSetting}>
                        <div className="row">
                            <div className="form-group">
                                <label className="font-weight-bold col-sm-12">Name :</label>
                                <input type="text" className="form-control "
                                    defaultValue={selectedRowData.data.vName}
                                    onChange={(e) => { setName(e.target.value) }}
                                    required />
                            </div>
                        </div>
                        <div className="row form-group">
                            <div className="col-sm-6">
                                <label className="col-sm-12 col-form-label font-weight-bold">Time Format</label>
                                <select
                                    className="form-control form-select text-left"
                                    defaultValue={sw.TimeFormat}
                                    onInvalid={(e) => e.target.setCustomValidity('Select Time Format')}
                                    onInput={(e) => e.target.setCustomValidity('')}
                                    onChange={(e) => setSettingValue({ ...settingValue, TimeFormat: e.target.value })}
                                    required
                                >
                                    <option value="" disabled>Select</option>
                                    <option value="0">12 Hours</option>
                                    <option value="1">24 Hours</option>
                                </select>
                            </div>
                            <div className="col-sm-6">
                                <label className="col-sm-12 col-form-label font-weight-bold">Temperature Unit</label>
                                <select
                                    className="form-control form-select text-left"
                                    defaultValue={sw.TemperatureUnit}
                                    onInvalid={(e) => e.target.setCustomValidity('Select Temperature Unit')}
                                    onInput={(e) => e.target.setCustomValidity('')}
                                    onChange={(e) => setSettingValue({ ...settingValue, TemperatureUnit: e.target.value })}
                                    required
                                >
                                    <option value="" disabled>Select</option>
                                    <option value="0">Celsius</option>
                                    <option value="1">Fahrenheit</option>
                                </select>
                            </div>
                        </div>
                        <div className="row  form-group">
                            <div className="col-sm-6 ">
                                <label className="col-sm-12 col-form-label font-weight-bold">Display Brightness Mode</label>
                                <select
                                    className="form-control form-select text-left"
                                    defaultValue={sw.DisplayBrightnessMode}
                                    onInvalid={(e) => e.target.setCustomValidity('Select Mode')}
                                    onInput={(e) => e.target.setCustomValidity('')}
                                    onChange={(e) => setSettingValue({ ...settingValue, DisplayBrightnessMode: e.target.value })}
                                    required
                                >
                                    <option value="" disabled>Select</option>
                                    <option value="0">Auto</option>
                                    <option value="1">Manual</option>
                                </select>
                            </div>
                            <div className="col-sm-6 ">
                                <label className="col-sm-12 col-form-label font-weight-bold">Brightness Value</label>
                                <div className="col-sm-12 mr-6">
                                    <Slider
                                        defaultValue={sw.DisplayBrightnessValue}
                                        disabled={settingValue?.DisplayBrightnessMode == "0"}
                                        value={marks.value}
                                        aria-labelledby="discrete-slider"
                                        valueLabelDisplay="auto"
                                        step={1}
                                        min={0}
                                        max={100}
                                        marks={marksBrightness}
                                        onChangeCommitted={(e, value) => setSettingValue({ ...settingValue, DisplayBrightnessValue: value })}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-sm-4 form-group text-center">
                                <label className="font-weight-bold col-sm-12">Sleep Mode</label>
                                <Switch
                                    className="form-control"
                                    defaultChecked={Boolean(sw.SleepMode)}
                                    onChange={(e, value) => setSettingValue({ ...settingValue, SleepMode: Number(value) })}
                                    name="Sleep Mode"
                                    color="primary" />
                            </div>
                            <div className="col-sm-4 form-group text-center">
                                <label className="font-weight-bold col-sm-12">Night Mode</label>
                                <Switch
                                    className="form-control"
                                    defaultChecked={Boolean(sw.NightMode)}
                                    onChange={(e, value) => setSettingValue({ ...settingValue, NightMode: Number(value) })}
                                    name="Night Mode"
                                    color="primary" />
                            </div>
                            <div className="col-sm-4 form-group text-center">
                                <label className="font-weight-bold col-sm-12">Outdoor Mode</label>
                                <Switch
                                    className="form-control"
                                    defaultChecked={Boolean(sw.OutdoorMode)}
                                    onChange={(e, value) => setSettingValue({ ...settingValue, OutdoorMode: Number(value) })}
                                    name="Outdoor Mode"
                                    color="primary" />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-sm-4 form-group text-center">
                                <label className="font-weight-bold col-sm-12">Weather Report</label>
                                <Switch
                                    className="form-control"
                                    defaultChecked={Boolean(sw.WeatherReport)}
                                    onChange={(e, value) => setSettingValue({ ...settingValue, WeatherReport: Number(value) })}
                                    name="Weather Report"
                                    color="primary" />
                            </div>
                            <div className="col-sm-4 form-group text-center">
                                <label className="font-weight-bold col-sm-12">Time</label>
                                <Switch
                                    className="form-control"
                                    defaultChecked={Boolean(sw.Time)}
                                    onChange={(e, value) => setSettingValue({ ...settingValue, Time: Number(value) })}
                                    name="Time"
                                    color="primary" />
                            </div>
                            <div className="col-sm-4 form-group text-center">
                                <label className="font-weight-bold col-sm-12">Room Temperature</label>
                                <Switch
                                    className="form-control"
                                    defaultChecked={Boolean(sw.RoomTemperature)}
                                    onChange={(e, value) => setSettingValue({ ...settingValue, RoomTemperature: Number(value) })}
                                    name="Room Temperature"
                                    color="primary" />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-sm-4 form-group text-center">
                            </div>
                            <div className="col-sm-4 form-group text-center">
                                <label className="font-weight-bold col-sm-12">Date</label>
                                <Switch
                                    className="form-control"
                                    defaultChecked={Boolean(sw.Date)}
                                    onChange={(e, value) => setSettingValue({ ...settingValue, Date: Number(value) })}
                                    name="Date"
                                    color="primary" />
                            </div>
                        </div>
                        <div className="row form-group mt-3 justify-content-sm-center ">
                            <Button type="submit" disabled={loading} className="col-sm-4 btn btn-light-primary px-9 py-3 my-3">
                                <span>Submit</span>
                                {loading && <span className="ml-3 spinner spinner-dark"></span>}
                            </Button>
                        </div>
                    </form>
                </div>
            </>)
    }

    // ------------------------------------------------------------
    //                form of 4sw SmarTap
    // ------------------------------------------------------------

    else if (selectedRowData.data.vSettingKey == "4_MODULE_DEFULT_SETTING_SMARTAP") {
        return (
            <>
                <hr className="solid m-7"></hr>
                <div className="container  ">
                    <div className="ml-5">
                        <form onSubmit={handleSubmitSetting}>

                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="form-group ">
                                        <label className="  col-form-label font-weight-bold">Name</label>
                                        <input type="text"
                                            className="form-control  "
                                            onInvalid={(e) => e.target.setCustomValidity('Enter Name')}
                                            onInput={(e) => e.target.setCustomValidity('')}
                                            defaultValue={selectedRowData.data.vName}
                                            onChange={(e) => { setName(e.target.value) }}
                                            required />
                                    </div>
                                </div>
                                <div className="col-sm-3 mt-4 form-group text-center">
                                    <label style={labelStyle} className="text-center font-weight-bold">{description.S1 == null ? ("S1") : ("S1" + ": " + description.S1)}</label>
                                    <Switch
                                        className="form-control col-sm-12"
                                        defaultChecked={Boolean(sw.S1)}
                                        onChange={(e, value) => setSettingValue({ ...settingValue, S1: Number(value) })}
                                        name="S1"
                                        color="primary" />
                                </div>
                                <div className="col-sm-3 mt-4 form-group text-center">
                                    <label style={labelStyle} className="font-weight-bold">{description.S2 == null ? ("S2") : ("S2" + ": " + description.S2)}</label>
                                    <Switch
                                        className="form-control col-sm-12"
                                        defaultChecked={Boolean(sw.S2)}
                                        onChange={(e, value) => setSettingValue({ ...settingValue, S2: Number(value) })}
                                        name="S2"
                                        color="primary" />
                                </div>
                            </div>

                            <div className="row text-center">
                                <div className="col-sm-3">
                                    <label style={labelStyle} className="font-weight-bold col-form-label">
                                        {description.DMR == null ? ("DMR") : ("DMR" + ": " + description.DMR)}
                                    </label>
                                    <Slider
                                        defaultValue={sw.DMR}
                                        value={marks.value}
                                        aria-labelledby="discrete-slider"
                                        valueLabelDisplay="auto"
                                        step={1}
                                        min={0}
                                        max={5}
                                        marks={marks}
                                        onChangeCommitted={(e, value) => setSettingValue({ ...settingValue, DMR: value })}
                                    />
                                </div>
                                <div className="col-sm-3">
                                    <label style={labelStyle} className="font-weight-bold">{description.S3 == null ? ("S3") : ("S3" + ": " + description.S3)}</label>
                                    <Switch
                                        className="form-control col-sm-12"
                                        defaultChecked={Boolean(sw.S3)}
                                        onChange={(e, value) => setSettingValue({ ...settingValue, S3: Number(value) })}
                                        name="S3"
                                        color="primary" />
                                </div>
                                <div className="col-sm-3">
                                    <label style={labelStyle} className=" font-weight-bold"> {description.S4 == null ? ("S4") : ("S4" + ": " + description.S4)}</label>
                                    <Switch
                                        className="form-control col-sm-12"
                                        defaultChecked={Boolean(sw.S4)}
                                        onChange={(e, value) => setSettingValue({ ...settingValue, S4: Number(value) })}
                                        name="S4"
                                        color="primary" />
                                </div>
                                <div className="col-sm-3">
                                    <label style={labelStyle} className="font-weight-bold  "> {description.FS == null ? ("FS") : ("FS" + ": " + description.FS)}</label>
                                    <Switch
                                        className=" form-control col-sm-12"
                                        defaultChecked={Boolean(sw.FS)}
                                        onChange={(e, value) => setSettingValue({ ...settingValue, FS: Number(value) })}
                                        name="FS"
                                        color="primary" />
                                </div>
                            </div>
                            <div className="row form-group mt-3 justify-content-sm-center ">
                                <Button type="submit" disabled={loading} className="col-sm-4 btn btn-light-primary px-9 py-3 my-3">
                                    <span>Submit</span>
                                    {loading && <span className="ml-3 spinner spinner-dark"></span>}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div >
            </>
        )
    }

    // ------------------------------------------------------------
    //                form of 1sw SmarTap
    // ------------------------------------------------------------

    else if (selectedRowData.data.vSettingKey == "1_MODULE_DEFULT_SETTING_SMARTAP") {
        return (
            <>
                <hr className="solid m-4"></hr>
                <div className="container  ">
                    <div className="ml-5">
                        <form onSubmit={handleSubmitSetting}>
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="form-group ">
                                        <label className="  col-form-label font-weight-bold">Name</label>
                                        <input type="text"
                                            className="form-control  "
                                            onInvalid={(e) => e.target.setCustomValidity('Enter Name')}
                                            onInput={(e) => e.target.setCustomValidity('')}
                                            defaultValue={selectedRowData.data.vName}
                                            onChange={(e) => { setName(e.target.value) }}
                                            required />
                                    </div>
                                </div>
                                <div className="col-sm-6 mt-4 form-group text-center">
                                    <label style={labelStyle} className="text-center font-weight-bold">{description.S1 == null ? ("S1") : ("S1" + ": " + description.S1)}</label>
                                    <Switch
                                        className="form-control col-sm-12"
                                        defaultChecked={Boolean(sw.S1)}
                                        onChange={(e, value) => setSettingValue({ ...settingValue, S1: Number(value) })}
                                        name="S1"
                                        color="primary" />
                                </div>
                            </div>
                            <div className="row form-group mt-3 justify-content-sm-center ">
                                <Button type="submit" disabled={loading} className="col-sm-4 btn btn-light-primary px-9 py-3 my-3">
                                    <span>Submit</span>
                                    {loading && <span className="ml-3 spinner spinner-dark"></span>}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div >
            </>
        )
    }

    else return <hr className="solid m-4"></hr>
}
